module.exports = __webpack_public_path__ + "static/media/profile-placeholder.99015d80.svg";